import React, { useEffect, useState } from 'react'
import { Box, CircularProgress, Dialog, Button, DialogContent, Typography } from '@mui/material'
import { CancelOutlined } from '@mui/icons-material'
import { Pagination } from '@mui/material'
import { getPDFPreviewData } from '../../../../utility/utilityFunctions'
import { useAuthContext } from '../../../../hooks/useAuthContext'
import BrokenImageIcon from '@mui/icons-material/BrokenImage'

const StandaloneFilePreview = ({ open, onClose, fileKey }) => {
  const { user } = useAuthContext()
  const [pos, setPos] = useState(1)
  const [pages, setPages] = useState(null)
  const [previewLoading, setPreviewLoading] = useState(false)

  useEffect(() => {
    ;(async () => {
      if (fileKey) {
        setPreviewLoading(true)
        let result = await getPDFPreviewData(fileKey, user)
        setPages(result)
        setPreviewLoading(false)
      }
    })()
  }, [fileKey])

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xxl">
      <Box sx={{ width: '100%' }}>
        {previewLoading ? (
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              flexDirection: 'column',
              width: '100%',
              minWidth: 600,
              maxWidth: 800,
              padding: '20px',
              height: 100,
            }}
          >
            <CircularProgress color="primary" size={24} />
            <Typography>Loading Preview</Typography>
          </Box>
        ) : (
          <Box
            sx={{
              width: '100%',
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              position: 'relative',
              height: pages?.length > 0 ? '100vh' : null,
            }}
          >
            <DialogContent sx={{ flex: '1 1 auto', width: '100%' }}>
              {pages?.length === 0 ? (
                <Box
                  sx={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    flexDirection: 'column',
                  }}
                >
                  <BrokenImageIcon color="lightgrey" />
                  <Typography>
                    Preview not available. Click the <b>Download</b> icon to download file
                  </Typography>
                </Box>
              ) : (
                <div style={{ position: 'relative', textAlign: 'center' }}>
                  {pages && (
                    <img
                      style={{ width: '100%', height: 'auto', maxWidth: '800px' }}
                      src={pages[pos - 1]}
                      alt="Image"
                    />
                  )}
                  <div
                    style={{
                      position: 'absolute',
                      top: 0,
                      right: 0,
                    }}
                  >
                    <Button color="info" size="small" onClick={onClose}>
                      <CancelOutlined size="small" />
                    </Button>
                  </div>
                </div>
              )}
            </DialogContent>
            {pages?.length > 0 && (
              <Box
                sx={{
                  maxWidth: '800px',
                  display: 'flex',
                  justifyContent: 'center',
                  padding: '10px',
                  backgroundColor: 'white',
                  position: 'fixed',
                  bottom: '5%',
                  left: '50%',
                  transform: 'translateX(-50%)',
                }}
              >
                <Pagination
                  count={pages?.length}
                  page={pos}
                  onChange={(_, pos) => setPos(pos)}
                  variant="outlined"
                  shape="rounded"
                />
              </Box>
            )}
          </Box>
        )}
      </Box>
    </Dialog>
  )
}

export default StandaloneFilePreview
